import { CloseIcon as UiCloseIcon } from "@l2r-front/l2r-icons"
import {
    styled,
    styledForMobile,
    Autocomplete as UiAutocomplete,
    TextField as UiTextField,
    L2RButton,
} from "@l2r-front/l2r-ui"

const WIDTH = 336
const DESKTOP__BUTTON_SIZE = 48
const MOBILE_BUTTON_SIZE = 44

export const Autocomplete = styledForMobile(UiAutocomplete)(({ theme, isMobile }) => ({
    width: isMobile ? "100%" : WIDTH,

    "&.MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
}))

export const TextField = styled(UiTextField)(({ theme }) => ({

    "& > .MuiInputBase-root": {
        borderRadius: theme.spacing(8),
        boxShadow: theme.customShadow("LCS/Shadow-simple"),
        backgroundColor: "white",
    },

    "& fieldset": {
        border: 0,
    },

}))

export const IconButton = styledForMobile(L2RButton)(({ theme, isMobile }) => ({
    "&.MuiIconButton-root": {
        boxShadow: theme.customShadow("LCS/Shadow-simple"),
        width: isMobile ? MOBILE_BUTTON_SIZE : DESKTOP__BUTTON_SIZE,
        height: isMobile ? MOBILE_BUTTON_SIZE : DESKTOP__BUTTON_SIZE,
        marginBottom: isMobile && theme.spacing(1),
    },
}))

export const CloseIcon = styled(UiCloseIcon)(() => ({
    cursor: "pointer",
}))

export const Wrapper = styledForMobile("div", ["displayAutoComplete"])(({ displayAutoComplete, isMobile }) => ({
    display: "flex",
    justifyContent: isMobile ? "flex-end" : "flex-start",
    width: (displayAutoComplete && isMobile) ? "100%" : "fit-content",
}))